import React from "react";
import UserRatingAndCurrentlyReading from "../shared/user_rating_and_currently_reading";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";

export default GrComponentFactory.createClass({
  displayName: "UserFollowingDetails",

  propTypes: {
    user: GrPropTypes.user().isRequired,
    followingUser: GrPropTypes.user().isRequired,
    ratingDetailsText: React.PropTypes.string,
    currentlyReadingBook: GrPropTypes.book(),
  },

  render() {
    const user = this.props.followingUser;
    return (
      <div className="gr-newsfeedItem__details">
        <a href={user.profileUrl} className="gr-newsfeedItem__resourceNameLink">
          {user.viewableName}
        </a>
        <UserRatingAndCurrentlyReading ratingDetailsText={this.props.ratingDetailsText}
                                       currentlyReadingBook={this.props.currentlyReadingBook} />
        <div>
          <a href={this.props.followingUser.profileUrl}
             className="gr-button u-marginTopMedium">
           View Profile
          </a>
        </div>
      </div>
    );
  },
});
